import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcddc148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container lg:px-8 xl:px-0" }
const _hoisted_2 = { class: "p-24 grid content-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`my-4 w-2/5 text-secondary`)
}
const _hoisted_5 = {
  class: "container lg:px-8 xl:px-0 pt-10",
  style: {"max-width":"1280px"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center mb-12"
}
const _hoisted_7 = { class: "py-4 text-3xl font-bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-1 w-20 border-t-4 border-highlight" }, null, -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = { class: "text-2xl font-bold" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-0.5 mt-2 border-t-4 border-highlight" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = { class: "text-base text-secondary" }
const _hoisted_17 = {
  key: 4,
  class: /*#__PURE__*/_normalizeClass(`pt-10 grid -gap-8 grid-cols-2`)
}
const _hoisted_18 = {
  key: 0,
  class: "float-left"
}
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "ml-20" }
const _hoisted_21 = { class: "text-2xl font-bold" }
const _hoisted_22 = { class: "text-base text-secondary" }
const _hoisted_23 = {
  key: 0,
  class: "card-icon flex justify-center -mt-12"
}
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "px-1" }
const _hoisted_26 = { class: "card-name text-center text-xl" }
const _hoisted_27 = { class: "card-summary pt-6 file:text-sm text-secondary" }
const _hoisted_28 = { class: "grid cols-4 items-center" }
const _hoisted_29 = { class: "card-name cols-span-3 text-3xl font-bold text-color1" }
const _hoisted_30 = {
  key: 0,
  class: "card-icon col-start-4 flex justify-center"
}
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "card-summary text-base text-secondary" }
const _hoisted_33 = { class: "card-name px-4 text-center text-sm" }
const _hoisted_34 = { class: "pt-4 text-base text-gray-600" }
const _hoisted_35 = {
  key: 0,
  class: "flex justify-center pt-10"
}
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "flex flex-col -gap-y-10" }
const _hoisted_38 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "flex justify-center text-2xl font-bold text-white" }
const _hoisted_41 = { class: "text-2xl font-bold" }
const _hoisted_42 = { class: "text-base text-secondary" }
const _hoisted_43 = {
  key: 9,
  class: /*#__PURE__*/_normalizeClass(`pt-10 grid -gap-8 grid-cols-2`)
}
const _hoisted_44 = { class: "flex justify-between items-center" }
const _hoisted_45 = { class: "text-base text-secondary" }
const _hoisted_46 = { class: "text-base" }
const _hoisted_47 = {
  key: 10,
  class: "pt-10 grid -gap-8 grid-cols-2"
}
const _hoisted_48 = { class: "flex justify-between items-center" }
const _hoisted_49 = { class: "text-2xl font-bold" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-12 h-0.5 mt-2 border-t-4 border-highlight" }, null, -1))
const _hoisted_51 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = { class: "text-base text-secondary" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  key: 1,
  class: "!bg-[#020618] p-4 !rounded-lg !mt-4"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white text-xl font-bold" }, "Primary Use", -1))
const _hoisted_57 = { class: "flex justify-center my-4" }
const _hoisted_58 = { class: "fixed right-4 top-20 z-50" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/ico_sai_meun.png",
  alt: "meun",
  class: "w-12 h-12"
}, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 0,
  class: "nav-card w-80 shadow-lg absolute right-0 rounded-lg text-sm text-right mt-4"
}
const _hoisted_62 = { class: "text-xl font-bold p-4 border-b-[1px] border-gray-500" }

import { ref, computed, onBeforeMount, onUnmounted, watch } from 'vue';
import { useMeta } from 'quasar';
import { useMetaStore } from 'stores/modules/meta';
import SvThumbnail from 'src/components/SvThumbnail.vue';
import ProductRegisterPage from 'pages/ProductRegisterPage.vue';
import AppLink from 'src/components/AppLink.vue';
import { useRoute  } from 'vue-router';
import { useI18n } from 'vue-i18n';


import { usePageStore } from 'stores/modules/page';
import tmpl from 'src/utils/tmpl';

const __default__ = {
  async preFetch({ store, currentRoute }) {
    const pageStore = usePageStore(store);
    await pageStore.fetch({ id: currentRoute.params.id as string });
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProductPage',
  setup(__props) {

const { t, locale } = useI18n();
const route = useRoute();

const isUnlocked = ref(false);
const showRegisterDialog = ref(false);

const pageStore = usePageStore();
const page = computed(() => pageStore.page);

const products = computed(() => {
 var productsMenu = pageStore.menus
      ?.find(menu => menu.title === 'Products & Solutions')
      ?.children
      ?.find(item => item.children?.find(child => child.children?.find(child => child.id === route.params.id))) 
      ?.children
      ?.find(item => item.children?.find(child => child.id === route.params.id)) 

  if(!productsMenu){
    productsMenu = pageStore.menus
    ?.find(menu => menu.title === 'Products & Solutions')
    ?.children
    ?.find(item => item.children?.find(child => child.id === route.params.id)) 
  }
  return productsMenu
})

const metaStore = useMetaStore();
useMeta(
  Object.assign({}, metaStore.meta, {
    title: page.value.title,
    titleTemplate: (title: string) => `${title} - ${metaStore.meta.title}`,
  })
);
const showNav = ref(false);

const toggleNav = () => {
  showNav.value = !showNav.value;
};

const handleScroll = () => {
  if(page.value.isRegistered){
    document.documentElement.style.overflow = 'hidden';  // html
    document.body.style.overflow = 'hidden';             // body
    const unlocked = getCookie('product_unlocked');
    if (unlocked === 'true') {
      isUnlocked.value = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }else{
      isUnlocked.value = false;
    }
  } else {
    isUnlocked.value = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }
}

onBeforeMount(() => {
  handleScroll()
});

watch(
  () => route.params.id,
  () => {
    handleScroll()
  }
)

onUnmounted(() => {
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
});

const handleSuccess = () => {
  showRegisterDialog.value = false
  const unlocked = getCookie('product_unlocked');
  if (unlocked === 'true') {
    isUnlocked.value = true;
    document.documentElement.style.overflow = 'auto';  // html
    document.body.style.overflow = 'auto';             // body
  } 
};

const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const background = (
  image: string,
  size = 'cover',
  position = 'center center'
) => {
  return image
    ? `background: url('${image}') no-repeat; background-size: ${size}; background-position: ${position}`
    : '';
};

const getCols = (length: number, onerow = 0) => {
  if (onerow > 0 && length <= onerow) return length;
  switch (length) {
    case 1:
    case 2:
    case 3:
      return length;
    case 4:
      return 2;
    default:
      return 3;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_page, { class: "flex justify-center" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.regions, (region) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: region.id
          }, [
            (region.type === 'summary')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "header w-full flex justify-center",
                  style: _normalizeStyle(background(region.image))
                }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`text-2xl ${
                region.extraProperties?.theme === 'dark' ? 'text-white' : ''
              }`),
                        innerHTML: region.name
                      }, null, 10, _hoisted_3),
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((region.summary ?? '').split('\n'), (p, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: i,
                            class: "text-justify"
                          }, _toDisplayString(p), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", null, [
                        (page.value.isRegistered)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              class: "w-40 h-11 mr-4",
                              "no-caps": "",
                              padding: "0",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showRegisterDialog.value = true)),
                              color: "linear-color2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(region.content || _unref(t)('Product.consult')), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (region.url && page.value.isRegistered)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              class: "w-40 h-11",
                              "no-caps": "",
                              padding: "0",
                              to: 
                  !/^\/api\/storage\//.test(region.url)
                    ? _unref(tmpl)(region.url, region)
                    : undefined
                ,
                              href: 
                  /^\/api\/storage\//.test(region.url)
                    ? _unref(tmpl)(region.url, region)
                    : undefined
                ,
                              color: "linear-color2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('Product.download')), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "href"]))
                          : _createCommentVNode("", true),
                        (region.url && !page.value.isRegistered)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 2,
                              class: "w-40 h-11",
                              "no-caps": "",
                              padding: "0",
                              to: 
                  !/^\/api\/storage\//.test(region.url)
                    ? _unref(tmpl)(region.url, region)
                    : undefined
                ,
                              href: 
                  /^\/api\/storage\//.test(region.url)
                    ? _unref(tmpl)(region.url, region)
                    : undefined
                ,
                              color: "linear-color2"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(region.content || _unref(t)('Product.consult')), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "href"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ], 4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "w-full flex justify-center locked-region",
                  style: _normalizeStyle(`${background(
          region.image,
          'cover',
          'bottom center;padding-top:60px;padding-bottom:170px;'
        )}`)
                }, [
                  (page.value.isRegistered && !isUnlocked.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "lock-mask",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (showRegisterDialog.value = true))
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    (region.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, _toDisplayString(region.name), 1),
                          _hoisted_8
                        ]))
                      : _createCommentVNode("", true),
                    (region.type === 'document')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(`ql-editor ${_unref(locale)?.split('-')[0]}`),
                          innerHTML: region.content
                        }, null, 10, _hoisted_9))
                      : _createCommentVNode("", true),
                    (region.type === 'image-list')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(SvThumbnail, {
                            regions: region.children,
                            "grid-class": "2xl:grid-cols-4 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1",
                            class: "img-card",
                            imageHeight: "300px",
                            ratio: "9/16",
                            autoplay: "",
                            infinite: ""
                          }, null, 8, ["regions"])
                        ]))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === 'default'
            )
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 3,
                          class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${getCols(
              region.children.length
            )}`)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full py-4 px-4 rounded-xl ${
                  child.image ? '' : 'bg-card'
                }`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "flex flex-col -gap-y-4" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createTextVNode(_toDisplayString(child.name) + " ", 1),
                                          _hoisted_13
                                        ]),
                                        (child.icon)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                              _createElementVNode("img", {
                                                class: "w-8 h-8",
                                                src: child.icon,
                                                alt: child.icon
                                              }, null, 8, _hoisted_15)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_16, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === 'theme1'
            )
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full p-8 rounded-none ${
                  child.image ? '' : 'bg-card'
                }`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "" }, {
                                    default: _withCtx(() => [
                                      (child.icon)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("img", {
                                              class: "w-14 h-14",
                                              src: child.icon,
                                              alt: child.icon
                                            }, null, 8, _hoisted_19)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(child.name), 1),
                                        _createElementVNode("div", _hoisted_22, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                            return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default').includes('悬浮卡片')
            )
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 5,
                          class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${region.children.length}`)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full p-4 rounded-2xl !bg-transparent opacity-90 hvr-float  ${
                  child.image ? '' : 'bg-card'
                } ${
                  (region.extraProperties?.theme ?? 'default').includes('反色')
                    ? 'reverse'
                    : ''
                }`)
                              }, {
                                default: _withCtx(() => [
                                  (child.icon)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createElementVNode("img", {
                                          class: "w-16 h-16",
                                          src: child.icon,
                                          alt: child.icon
                                        }, null, 8, _hoisted_24)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_q_card_section, { class: "py-4" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, _toDisplayString(child.name), 1),
                                        _createElementVNode("div", _hoisted_27, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                            return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === '默认样式改'
            )
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 6,
                          class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${getCols(
              region.children.length,
              4
            )}`)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full py-4 px-4 rounded-xl hvr-float ${
                  child.image ? '' : 'bg-card deep'
                }`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "flex flex-col -gap-y-4" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, _toDisplayString(child.name), 1),
                                        (child.icon)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                              _createElementVNode("img", {
                                                class: "w-16",
                                                src: child.icon,
                                                alt: child.icon
                                              }, null, 8, _hoisted_31)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_32, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === '图文卡片'
            )
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 7,
                          class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${getCols(
              region.children.length
            )}`)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, { class: "h-full bg-card !bg-transparent" }, {
                                default: _withCtx(() => [
                                  (child.image)
                                    ? (_openBlock(), _createBlock(_component_q_img, {
                                        key: 0,
                                        src: child.image,
                                        alt: child.name,
                                        loading: "lazy"
                                      }, {
                                        loading: _withCtx(() => [
                                          _createVNode(_component_q_spinner_dots, {
                                            color: "primary",
                                            size: "1.5rem"
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["src", "alt"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_q_card_section, { class: "p-10" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(child.name), 1),
                                      _createElementVNode("div", _hoisted_34, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                        }), 128))
                                      ]),
                                      (child.icon)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            _createElementVNode("img", {
                                              class: "w-20 h-20",
                                              src: child.icon,
                                              alt: child.icon
                                            }, null, 8, _hoisted_36)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === '背景图文卡片'
            )
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 8,
                          class: _normalizeClass(`pt-10 grid -gap-8 grid-cols-${getCols(
              region.children.length,
              4
            )}`)
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full rounded-xl ${child.image ? '' : 'bg-card'}`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "lg:h-96 lg:pt-20 xl:h-auto xl:pb-36" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_37, [
                                        (child.icon)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                              _createElementVNode("img", {
                                                class: "w-20 h-20",
                                                src: child.icon,
                                                alt: child.icon
                                              }, null, 8, _hoisted_39)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_40, [
                                          _createElementVNode("div", _hoisted_41, _toDisplayString(child.name), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                            return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === '简洁卡片'
            )
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full px-4 rounded-xl ${
                  child.image ? '' : 'bg-card'
                }`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "flex flex-col -gap-y-1" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("div", _hoisted_45, _toDisplayString(child.name), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_46, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(p), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (
              region.type === 'data-list' &&
              (region.extraProperties?.theme ?? 'default') === '父子卡片'
            )
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(region.children, (child) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: child.id
                            }, [
                              _createVNode(_component_q_card, {
                                class: _normalizeClass(`h-full py-4 px-4 rounded-xl ${
                  child.image ? '' : 'bg-card'
                }`),
                                style: _normalizeStyle(background(child.image))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, { class: "flex flex-col -gap-y-4" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("div", _hoisted_49, [
                                          _createTextVNode(_toDisplayString(child.name) + " ", 1),
                                          _hoisted_50
                                        ]),
                                        (child.icon)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                              _createElementVNode("img", {
                                                class: "w-8 h-8",
                                                src: child.icon,
                                                alt: child.icon
                                              }, null, 8, _hoisted_52)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_53, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((child.summary ?? '').split('\n'), (p, i) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                            (i === 0)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(p), 1))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                  _hoisted_56,
                                                  _createElementVNode("p", null, _toDisplayString(p), 1)
                                                ]))
                                          ], 64))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["class", "style"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 4))
          ], 64))
        }), 128)),
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_q_btn, {
            class: "w-40 h-11",
            "no-caps": "",
            padding: "0",
            href: "/about/contact-us",
            color: "linear-color2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Contact.contact')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", {
            class: "cursor-pointer transition-transform transform hover:scale-110",
            onClick: toggleNav
          }, _hoisted_60),
          (showNav.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, _toDisplayString(products.value.title), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value.children, (product) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: product.id,
                    class: "px-2"
                  }, [
                    (product.title)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["my-4 cursor-pointer hover:text-yellow-500 border-r-4 border-gray-500 hover:border-yellow-500 p-2", _unref(route).params.id === product.id 
            ? 'text-yellow-500 border-yellow-500' 
            : ''])
                        }, [
                          (product.url)
                            ? (_openBlock(), _createBlock(AppLink, {
                                key: 0,
                                to: _unref(tmpl)(product.url, product)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(product.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: showRegisterDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showRegisterDialog).value = $event)),
      class: "overflow-hidden"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(ProductRegisterPage, {
              modelValue: showRegisterDialog.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showRegisterDialog).value = $event)),
              onSuccess: handleSuccess
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})